import { useState, useEffect } from "react"
import * as tf from "@tensorflow/tfjs"

const modelPath = "/model.json"

const useModel = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [model, setModel] = useState<tf.LayersModel>(undefined)

  useEffect(() => {
    tf.loadLayersModel(modelPath).then(model => {
      setModel(model)
      setIsLoading(false)
    })
  }, [])

  return {
    isLoading,
    model,
  }
}

export default useModel
